"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _checkboxHelpers = require("./checkboxHelpers");
var _green = _interopRequireDefault(require("../../tokens/color/green"));
var _teal = _interopRequireDefault(require("../../tokens/color/teal"));
// libraries

// helpers

var Checkbox = function Checkbox(props) {
  var checkboxType = (0, _checkboxHelpers.getType)(props.disabled, props.solid);

  // eslint-disable-next-line no-unused-vars
  var onToggle = function onToggle(e) {
    e.stopPropagation();
    e.persist();
    props.onChange((0, _defineProperty2["default"])({}, props.value, !props.checked), e);
  };
  return /*#__PURE__*/_react["default"].createElement(Checkbox.Label, props, /*#__PURE__*/_react["default"].createElement(Checkbox.Element, {
    key: props.value,
    disabled: props.disabled,
    cbType: checkboxType,
    type: "checkbox",
    onChange: onToggle,
    checked: props.checked,
    "aria-checked": props.checked,
    color: props.color
  }), props.label);
};
var getCursorState = function getCursorState(_ref) {
  var disabled = _ref.disabled;
  return disabled ? "not-allowed" : "pointer";
};
Checkbox.Label = _styledComponents["default"].label.withConfig({
  componentId: "sc-1o2pknd-0"
})(["font-size:14px;line-height:1.2;color:#1c1c1c;height:18px;cursor:", ";display:flex;align-items:center;justify-content:start;height:100%;width:max-content;"], getCursorState);
Checkbox.Element = _styledComponents["default"].input.withConfig({
  componentId: "sc-1o2pknd-1"
})(["appearance:none;cursor:", ";outline:0;border-radius:4px;margin-right:8px;width:18px;height:18px;background:#fff;border:2px solid ", ";box-sizing:border-box;position:relative;&:hover{border:2px solid ", ";}transition:all 0.4s;&:checked::after{position:absolute;top:3.5%;left:30%;width:0.55rem;height:1rem;content:\"\";border-color:", ";border-style:solid;border-top:0;border-right-width:2px;border-bottom-width:2px;border-left:0;transform:rotate(48deg);}&:checked{border:2px solid ", ";background:", ";}"], getCursorState, (0, _checkboxHelpers.getAttributes)("borderColor"), (0, _checkboxHelpers.getAttributes)("hoverBorderColor"), (0, _checkboxHelpers.getClickedAttributes)("tickColor"), (0, _checkboxHelpers.getClickedAttributes)("borderColor"), (0, _checkboxHelpers.getClickedAttributes)("background"));
Checkbox.propTypes = {
  label: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  solid: _propTypes["default"].bool,
  color: _propTypes["default"].string
};
Checkbox.defaultProps = {
  disabled: false,
  onChange: _noop2["default"],
  checked: false,
  solid: true,
  color: _teal["default"].z500
};
var _default = exports["default"] = Checkbox;